(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/europatipset/assets/javascripts/my-bets-route.js') >= 0) return;  svs.modules.push('/modules/europatipset/assets/javascripts/my-bets-route.js');
"use strict";


const ProtectedRoute = svs.components.lbUtils.protectedRoute.ProtectedRoute;
const _ReactRouterDOM = ReactRouterDOM,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const tipsenLazy = svs.components.tipsen.tipsenLazy.tipsenLazy;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const RouteMyBetsWagerFallback = svs.components.tipsen.modularBase.RouteMyBetsWagerFallback;

const LazyRouteMyBets = tipsenLazy('route-my-bets', () => svs.europatipset.components.RouteMyBets, {
  fallback: () => null
});
const LazyRouteMyBetsWager = tipsenLazy('route-my-bets-wager', () => svs.europatipset.components.routeMyBetsWager.RouteMyBetsWager, {
  fallback: RouteMyBetsWagerFallback
});
const allowedRoles = ['Player', 'CustomerService'];
const MyBetsRoute = () => React.createElement(ProtectedRoute, {
  roles: allowedRoles
}, React.createElement(Switch, null, React.createElement(Route, {
  component: LazyRouteMyBetsWager,
  path: "/".concat(TipsenModuleGameUrl.MY_BETS, "/:wagerId(\\d+)")
}), React.createElement(Route, {
  component: LazyRouteMyBets
})));
setGlobal('svs.europatipset.MyBetsRoute', MyBetsRoute);

 })(window);